<template>
  <div>
    <form id="create_gift_card">
      <div class="card card-custom gutter-b">
        <div class="card-header">
          <div class="card-title">
            <h3 class="card-label">ایجاد کد هدیه</h3>
          </div>
        </div>
        <div class="card-body">
          <div class="container">
            <div class="row">
              <div class="form-group col-12">
                <label>عنوان</label>
                <input
                  type="text"
                  name="title"
                  v-model="form.title"
                  class="form-control form-control-solid"
                />
              </div>
              <div class="form-group col-6">
                <label>تعداد</label>
                <input
                  type="text"
                  name="count"
                  v-model="form.count"
                  class="form-control form-control-solid"
                />
              </div>
              <div class="form-group col-6">
                <label>قیمت</label>
                <input
                  type="text"
                  name="value"
                  v-model="form.value"
                  class="form-control form-control-solid"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
    <div class="form-group col-6" v-if="giftCardsCodes.length">
      <h4 class="card-label">لیست کدهای کارت هدیه</h4>
      <template v-for="(code, index) in giftCardsCodes">
        <b-list-group :key="index">
          <b-list-group-item>{{ code }}</b-list-group-item>
        </b-list-group>
      </template>
    </div>
    <div class="form-group col-6" v-if="giftCardsCodes.length">
      <button class="btn btn-xs btn-primary" @click="download()">
        دانلود لیست کدها
      </button>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { SET_ACTIONS } from "@/core/services/store/actions.module";
import formValidation from "@/assets/plugins/formvalidation/dist/es6/core/Core";
import Trigger from "@/assets/plugins/formvalidation/dist/es6/plugins/Trigger";
import Bootstrap from "@/assets/plugins/formvalidation/dist/es6/plugins/Bootstrap";
import { STORE_ADMIN_GIFT_CARDS } from "@/core/services/store/admin/giftcards.module";
import { mapGetters } from "vuex";
import Swal from "sweetalert2";

export default {
  name: "adminUsersCreate",
  data() {
    return {
      form: {
        title: "",
        count: "",
        value: ""
      },
      loaded: false,
      baseUrl: process.env.VUE_APP_API_BASE_URL
    };
  },
  components: {},
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "کارت هدیه", route: { name: "admin-gift-cards" } },
      { title: "افزودن" }
    ]);

    this.$store.dispatch(SET_ACTIONS, {
      buttons: [
        {
          name: "ذخیره",
          event: "save-gift-event",
          class: "btn-primary",
          id: "save-gift-btn"
        }
      ],
      links: [
        {
          name: "بازگشت",
          to: { name: "admin-gift-cards" }
        }
      ]
    });
    this.eventHub.$on("save-gift-event", this.save);
    this.eventHub.$on("delete-gift-event", this.destroy);

    this.fv = formValidation(document.getElementById("create_gift_card"), {
      fields: {
        title: {
          validators: {
            notEmpty: {
              message: "عنوان صحیح نیست."
            }
          }
        },
        count: {
          validators: {
            notEmpty: {
              message: "تعداد صحیح نیست."
            }
          }
        },
        value: {
          validators: {
            notEmpty: {
              message: "قیمت صحیح نیست."
            }
          }
        }
      },
      plugins: {
        trigger: new Trigger(),
        bootstrap: new Bootstrap()
      }
    });
  },
  beforeDestroy() {
    this.eventHub.$off(["save-gift-event"]);
    document.getElementById("save-gift-btn").disabled = false;
  },
  computed: {
    ...mapGetters(["giftCardsCodes", "giftCardsPath"])
  },
  methods: {
    save() {
      this.fv.validate().then(status => {
        if (status === "Valid") {
          let submitBtn = document.getElementById("save-gift-btn");
          this.disableBtn(submitBtn);
          this.$store
            .dispatch(STORE_ADMIN_GIFT_CARDS, {
              title: this.form.title,
              count: this.form.count,
              value: this.form.value
            })
            .then(() => {
              this.enableBtn(submitBtn);
              Swal.fire({
                icon: "success",
                title: "عملیات با موفقیت انجام شد",
                showConfirmButton: false,
                timer: 1500
              });
              this.form = {};
            })
            .catch(e => {
              if (e.status === 404) {
                Swal.fire({
                  title: "",
                  text: "کد وارد شده صحیح نیست",
                  icon: "error",
                  showCloseButton: false,
                  confirmButtonText: "بستن",
                  confirmButtonColor: "#4554a0",
                  heightAuto: false
                });
              } else if (e.status === 422) {
                Swal.fire({
                  title: "",
                  text: e.data.error,
                  icon: "error",
                  showCloseButton: false,
                  confirmButtonText: "بستن",
                  confirmButtonColor: "#4554a0",
                  heightAuto: false
                });
              }
              this.enableBtn(submitBtn);
            });
        } else if (status === "Invalid") {
          this.showError("لطفا فرم را به شکل صحیح کامل کنید");
        }
      });
    },
    download() {
      let url = this.baseUrl.replace("app/v2/", "") + this.giftCardsPath;
      this.downloadFile(url);
    }
  }
};
</script>
